module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('back-button'), _vm._v(" "), _c('swipe', {
    staticClass: "container"
  }, [_c('swipe-item', [_c('h1', [_vm._v("1")])]), _vm._v(" "), _c('swipe-item', [_c('h1', [_vm._v("2")])]), _vm._v(" "), _c('swipe-item', [_c('div', {
    staticClass: "scroll-wrap"
  }, [_c('div', {
    staticClass: "scroll"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('p', {
      domProps: {
        "textContent": _vm._s(index)
      }
    })
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f6f0c8c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/ScrollingContent.vue
// module id = 33
// module chunks = 0